import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

const STATS = [
  { valor: 2011, prefixo: "", label: "Ano de fundação", animar: false },
  { valor: 4000, prefixo: "+", label: "Seguidores", animar: true },
  { valor: 15, prefixo: "+", label: "Anos formando atletas", animar: true },
  { valor: 6, prefixo: "", label: "Categorias — SUB 5 ao SUB 15", animar: true },
];

const Counter = ({ stat }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [valor, setValor] = useState(stat.animar ? 0 : stat.valor);

  useEffect(() => {
    if (!inView || !stat.animar) return;
    const controls = animate(0, stat.valor, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setValor(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, stat]);

  return (
    <div ref={ref} data-testid={`stat-${stat.label.slice(0, 12).replace(/\s/g, "-")}`} className="text-center">
      <p className="font-display text-5xl tracking-wide text-gold sm:text-6xl lg:text-7xl">
        {stat.prefixo}
        {valor.toLocaleString("pt-BR")}
      </p>
      <p className="mt-2 text-xs font-semibold uppercase tracking-[0.2em] text-white/70 sm:text-sm">
        {stat.label}
      </p>
    </div>
  );
};

const Stats = () => (
  <section data-testid="stats-bar" className="gold-specks relative border-y border-white/10 bg-navy py-16">
    <div className="mx-auto grid max-w-6xl grid-cols-2 gap-10 px-4 sm:px-6 lg:grid-cols-4 lg:px-8">
      {STATS.map((s) => (
        <Counter key={s.label} stat={s} />
      ))}
    </div>
  </section>
);

export default Stats;
